import(/* webpackMode: "eager" */ "/data1/service/src/app/error.jsx")